import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-card-image-bento__slider .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const settings = {
			loop: false,
			grabCursor: false,
			spaceBetween: 16,
			slidesPerView: 2,
			modules: [A11y, Navigation, Pagination],
			slideClass: 'block-card-bento',
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			pagination: {
				el: slider.parentElement.querySelector('.swiper-pagination'),
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			breakpoints: {
				576: {
					slidesPerView: 3,
				},
				992: {
					spaceBetween: 16,
					slidesPerView: 4,
				},
				1200: {
					spaceBetween: 24,
					slidesPerView: 5,
				},
				1500: {
					spaceBetween: 24,
					slidesPerView: 6,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
